import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.pesquisa(payload).then(res => {
        dispatch('ActionSetCategorias',res)
    }).catch(err => {
        dispatch('ActionSetCategorias',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.delete(payload).then(res => {
       
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPerfil = ({dispatch},payload)=>{
    return serves.trabalhadorlotacao.show(payload).then(res => {
        dispatch('ActionSetPerfil',res)
    }).catch(err => {
        dispatch('ActionSetPerfil',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetCategorias = ({commit},payload) =>{
    commit(types.SET_CATEGORIAS,payload)
}
export const ActionSetPerfil = ({commit},payload) =>{
    commit(types.SET_PERFIL,payload)
}
